import { render, staticRenderFns } from "./Scene3.vue?vue&type=template&id=78d930a3&"
import script from "./Scene3.vue?vue&type=script&lang=js&"
export * from "./Scene3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports